/**
 * A tab left open across a deploy keeps running the bundle it loaded, while the api it calls
 * moves on: a response carrying a field or enum member that bundle's schemas predate fails to
 * parse on every request, and no reload ever happens on its own. Hosting serves the page
 * itself `no-cache`, so the deployed page names the current entry script; when it differs from
 * the one this tab runs, reloading is the only way the tab can read the api again.
 */

const ENTRY = /<script[^>]*type="module"[^>]*src="([^"]+)"/;

export async function reloadIfRedeployed(
  doc: Document = document,
  fetchPage: (url: string) => Promise<Response> = (url) => fetch(url, { cache: 'no-store' }),
  reload: () => void = () => {
    window.location.reload();
  },
): Promise<boolean> {
  const running = doc.querySelector('script[type="module"][src]')?.getAttribute('src') ?? null;
  if (running === null) return false;
  let deployed: string | null;
  try {
    const page = await fetchPage(`${doc.location.origin}${doc.location.pathname}`);
    deployed = page.ok ? (ENTRY.exec(await page.text())?.[1] ?? null) : null;
  } catch {
    return false;
  }
  if (deployed === null || deployed === running) return false;
  reload();
  return true;
}
